import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_470: DocMigration = {
  maxSchemaVersion: "0.0.470",
  description: "Migrate various framing settings to new settings",
  apply(json: any) {
    const openings = json.openings;

    for (const openingId in openings) {
      const { entityType } = openings[openingId];

      if (entityType === "OPENING") {
        const framing = openings[openingId].framing || {};
        if (framing.hasOwnProperty("hasJackStuds") && !framing.hasJackStuds) {
          framing.numberOfJackStuds = 0;
        }

        if (
          openings[openingId].framing &&
          (framing["hasDoubleKingStuds"] || !framing.hasOwnProperty("hasDoubleKingStuds"))
        ) {
          framing["numberOfKingStuds"] = 2;
        }
        if (!framing.hasOwnProperty("hasDoubleHeader") || framing.hasDoubleHeader) {
          framing["hasDoubleHeaderLegacy"] = true;
        } else {
          framing["hasDoubleHeaderLegacy"] = false;
        }

        delete framing.hasJackStuds;
        delete framing.hasDoubleKingStuds;
        openings[openingId].framing = framing;
      }
    }

    // add them to the existing wainscoting settings
    for (const settingId in json?.settings) {
      const setting = json.settings[settingId];
      if (setting?.type === "WINDOW_FRAMING_SETTINGS" || setting?.type === "DOOR_FRAMING_SETTINGS") {
        if (setting.hasOwnProperty("hasJackStuds") && !setting.hasJackStuds) {
          setting["numberOfJackStuds"] = 0;
        }
        if (setting.hasOwnProperty("hasDoubleKingStuds") && setting.hasDoubleKingStuds) {
          setting["numberOfKingStuds"] = 2;
        }
        if (!setting.hasOwnProperty("hasDoubleHeader") || setting.hasDoubleHeader) {
          setting["hasDoubleHeaderLegacy"] = true;
        } else {
          setting["hasDoubleHeaderLegacy"] = false;
        }
        delete setting.hasDoubleHeader;
        delete setting.hasJackStuds;
        delete setting.hasDoubleKingStuds;
      }
      if (setting?.type === "WINDOW_CATALOG_SETTINGS") {
        const windowTypes = setting.windowTypes;
        for (const windowTypeId in windowTypes) {
          const windowType = windowTypes[windowTypeId];
          const windowFraming = windowType.framing || {};

          if (windowFraming.hasOwnProperty("hasJackStuds") && !windowFraming.hasJackStuds) {
            windowFraming.numberOfJackStuds = 0;
          }

          if (
            windowType.framing &&
            (windowFraming["hasDoubleKingStuds"] || !windowFraming.hasOwnProperty("hasDoubleKingStuds"))
          ) {
            windowFraming["numberOfKingStuds"] = 2;
          }
          if (!windowFraming.hasOwnProperty("hasDoubleHeader") || windowFraming.hasDoubleHeader) {
            windowFraming["hasDoubleHeaderLegacy"] = true;
          } else {
            windowFraming["hasDoubleHeaderLegacy"] = false;
          }
          delete windowFraming.hasDoubleHeader;
          delete windowFraming.hasJackStuds;
          delete windowFraming.hasDoubleKingStuds;
          windowType.framing = windowFraming;
        }
      }
      if (setting?.type === "DOOR_CATALOG_SETTINGS") {
        const doorTypes = setting.doorTypes;
        for (const doorTypeId in doorTypes) {
          const doorType = doorTypes[doorTypeId];
          const doorFraming = doorType.framing || {};

          if (!doorFraming.hasJackStuds && doorFraming.hasOwnProperty("hasJackStuds")) {
            doorFraming.numberOfJackStuds = 0;
          }

          if (
            doorType.framing &&
            (doorFraming["hasDoubleKingStuds"] || !doorFraming.hasOwnProperty("hasDoubleKingStuds"))
          ) {
            doorFraming["numberOfKingStuds"] = 2;
          }
          if (!doorFraming.hasOwnProperty("hasDoubleHeader") || doorFraming.hasDoubleHeader) {
            doorFraming["hasDoubleHeaderLegacy"] = true;
          } else {
            doorFraming["hasDoubleHeaderLegacy"] = false;
          }
          delete doorFraming.hasDoubleHeader;
          delete doorFraming.hasJackStuds;
          delete doorFraming.hasDoubleKingStuds;
          doorType.framing = doorFraming;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_470;
